"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var html_definitions_1 = require("./html-definitions");
var OverviewComponent = /** @class */ (function () {
    function OverviewComponent(model) {
        var _this = this;
        this.preview_width = 250;
        this.model = model;
        this.slide_view = document.querySelector('#rslidy-overview-slides');
        this.toc_view = document.querySelector('#rslidy-overview-toc');
        var nubs = document.querySelector('#rslidy-progress-bar-nubs');
        // Iterate over all slides and set up the overview and toc
        for (var i = 0; i < window.rslidy.num_slides; i++) {
            var slideHtml = model[i];
            var title = i + 1 + ". " + this.getSlideHeading(slideHtml);
            var xofy = i + 1 + " / " + window.rslidy.num_slides;
            var thumbnail = window.rslidy.utils.appendHtmlString(this.slide_view, html_definitions_1.thumbnail_html(i, xofy, slideHtml, ""));
            thumbnail.addEventListener("click", function (e) {
                return _this.slideSelected(e);
            });
            var pv = window.rslidy.utils.appendHtmlString(nubs, html_definitions_1.preview_html(i));
            pv.style.width = "calc(100%/" + window.rslidy.num_slides + ")";
            pv.style.left = "calc((100%/" + window.rslidy.num_slides + ")*" + i + ")";
            if (!window.rslidy.show_slide_dividers)
                pv.classList.add("rslidy-nonubs");
            pv.addEventListener("click", function (e) {
                return window.rslidy.content.showSlide(Number(e.target.dataset.slideindex), false);
            });
            pv.addEventListener("mouseover", function (e) {
                return _this.showPreview(e.target);
            });
            pv.addEventListener("mouseout", function (e) {
                return _this.removePreview(e.target);
            });
            var link = window.rslidy.utils.appendHtmlString(this.toc_view, html_definitions_1.link_html(i, title));
            link.addEventListener("click", function (e) {
                return _this.slideSelected(e);
            });
        }
        this.slide_view.classList.add("rslidy-overview");
        this.toc_view.classList.add("rslidy-overview");
        this.adjustOverviewPanel();
        window.rslidy.utils.switchElementsClass([this.toc_view], "rslidy-invisible");
        window.rslidy.utils.switchElementsClass([this.slide_view], "rslidy-invisible");
    }
    // ---
    // Description: Adjust the overview panel
    // ---
    OverviewComponent.prototype.adjustOverviewPanel = function () {
        this.adjustPanel("");
    };
    // ---
    // Description: Adjust the progressbar preview panels
    // ---
    OverviewComponent.prototype.adjustPreviewPanel = function () {
        this.adjustPanel("-pv");
    };
    // ---
    // Description: Adjusts the aspect ratio and display sizes of the thumbnail
    // images in the overview menu.
    // suffix: used by the wrapper functions above
    // ---
    OverviewComponent.prototype.adjustPanel = function (suffix) {
        // Get items
        var thumbnail_wrappers = document.getElementsByClassName("rslidy-slide-thumbnail" + suffix);
        var overview_items = document.getElementsByClassName("rslidy-overview-item" + suffix);
        // Get the percentage of width pixels of the overview section with respect
        // to window.outerWidth
        var aspect_ratio = window.rslidy.custom_aspect_ratio != 0
            ? window.rslidy.custom_aspect_ratio
            : window.rslidy.utils.getCurrentAspectRatio();
        var overview_slide_zoom = window.rslidy.overview_slide_zoom;
        var custom_width = window.rslidy.custom_width;
        var final_width = custom_width / overview_slide_zoom;
        var overview_width = this.slide_view.clientWidth;
        if (suffix == "-pv")
            overview_width = this.preview_width;
        var relative_width = window.rslidy.utils.getRelativeWidth(overview_width, aspect_ratio, final_width);
        for (var i = 0; i < overview_items.length; i++) {
            // 1. Set width and height of the overview element to outerWidth and
            // outerHeight, respectively
            overview_items[i].style.width =
                window.rslidy.utils.getSlideWidth(aspect_ratio, final_width) + "px";
            overview_items[i].style.height =
                window.rslidy.utils.getSlideHeight(aspect_ratio, final_width) + "px";
            // 2. Do the transformation of the overview element now with
            // relative_width (browser compatibility)
            var scale_value = "scale3d(" +
                relative_width + ", " + relative_width + ", " + relative_width + ")";
            var origin_value = "0 0 0";
            overview_items[i].style.transform = scale_value; // safety first
            overview_items[i].style.transformOrigin = origin_value; // safety first
            overview_items[i].style.MozTransform = scale_value;
            overview_items[i].style.MozTransformOrigin = origin_value;
            overview_items[i].style.webkitTransform = scale_value;
            overview_items[i].style.webkitTransformOrigin = origin_value;
            overview_items[i].style.msTransform = scale_value;
            overview_items[i].style.msTransformOrigin = origin_value;
            // 3. Now, set the width pixels of the wrapper element to the overview
            // width pixels and calculate its height with the aspect ratio
            var w = overview_width;
            var h = w /
                (window.rslidy.utils.getSlideWidth(aspect_ratio, final_width) /
                    window.rslidy.utils.getSlideHeight(aspect_ratio, final_width));
            if (suffix == "-pv")
                thumbnail_wrappers[i].style.width = (w - 20) + "px";
            thumbnail_wrappers[i].style.height = (h - 20) + "px";
        }
    };
    // ---
    // Description: Returns the heading of a slide if available (or "slide" if
    // not found).
    // slide_element: The slide element to get the heading from.
    // ---
    OverviewComponent.prototype.getSlideHeading = function (slide_element) {
        if (slide_element.indexOf("<h1>") !== -1)
            return slide_element.substring(slide_element.indexOf("<h1>") + 4, slide_element.indexOf("</h1>"));
        else if (slide_element.indexOf("<h2>") !== -1)
            return slide_element.substring(slide_element.indexOf("<h2>") + 4, slide_element.indexOf("</h2>"));
        else if (slide_element.indexOf("<h3>") !== -1)
            return slide_element.substring(slide_element.indexOf("<h3>") + 4, slide_element.indexOf("</h3>"));
        else
            return "slide";
    };
    // ---
    // Description: Show a slide preview on the progressbar
    // e: the mouseover event
    // ---
    OverviewComponent.prototype.showPreview = function (e) {
        var _this = this;
        var i = Number(e.dataset.slideindex);
        var slideHtml = this.model[i];
        var xofy = i + 1 + " / " + window.rslidy.num_slides;
        var child = e.children[0];
        var thumbnail = window.rslidy.utils.appendHtmlString(child, html_definitions_1.thumbnail_html(i, xofy, slideHtml, "-pv"));
        thumbnail.addEventListener("touchstart", function (e2) {
            _this.slideSelected(e2);
            _this.removePreview(e);
        });
        if (window.rslidy.low_light_mode) {
            var elements = child.getElementsByTagName("img");
            window.rslidy.utils.switchElementsClass(elements, "rslidy-color-invert");
        }
        var y = window.innerHeight - e.getBoundingClientRect().bottom + 20;
        var x = e.offsetLeft + e.offsetWidth / 2;
        x -= this.preview_width / 2;
        if (x < 0)
            x = 0;
        if (x > window.innerWidth - this.preview_width + 12)
            child.style.right = "0px";
        else
            child.style.left = x + "px";
        child.style.bottom = y + "px";
        this.adjustPreviewPanel();
    };
    // ---
    // Description: Remove a slide preview from the progressbar
    // e: the mouseout event
    // ---
    OverviewComponent.prototype.removePreview = function (e) {
        e.children[0].innerHTML = '';
    };
    // ---
    // Description: Called whenever a slide thumbnail in the overview gets
    // clicked.
    // e: Event.
    // ---
    OverviewComponent.prototype.slideSelected = function (e) {
        // Get the click target
        var target = e.target;
        // Fix for z-index bug on iOS
        while (target.className != "rslidy-slide-clickelement" &&
            target.className != "rslidy-slide-link")
            target = target.parentElement;
        // Get the index of the slide
        var slide_index = Number(target.dataset.slideindex);
        // Switch to this slide
        window.rslidy.content.showSlide(slide_index, false);
        // Close overview menu if desired
        if (window.rslidy.close_navigation_on_selection == true) {
            if (this.slide_view.classList.contains("rslidy-overview-visible"))
                window.rslidy.toolbar.overviewToggleClicked();
            if (this.toc_view.classList.contains("rslidy-overview-visible"))
                window.rslidy.toolbar.tocToggleClicked();
        }
        // Prevent link clicking (iOS)
        e.preventDefault();
    };
    return OverviewComponent;
}());
exports.OverviewComponent = OverviewComponent;
